import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { log } from 'utils/Logger'

export function initTweensManager() {
  signal.on('REELS-START', enable)
  signal.on('REELS-RESTART', enable)
  signal.on('REELS-STOP', disable)

  function nitro() {
    game.parameter.nitro = true
    gsap.globalTimeline.timeScale(game.gui.global.timeScale * 3 )
    log('SPIN-NITRO-ON')
  }

  function enable() {
    signal.once('BUTTON:spin', nitro)
  }

  function disable() {
    log('SPIN-NITRO-OFF')
    game.parameter.nitro = false
    signal.off('BUTTON:spin', nitro)
    gsap.globalTimeline.timeScale(game.gui.global.timeScale)
  }

}
